import IntlMessageFormat from 'intl-messageformat';
import i18n from 'shared/i18n';
import getMessages from 'messages';

function bilingualMessage(id, values) {
  const primary = new IntlMessageFormat(i18n.messages[id] || id || '', i18n.locale).format(values);

  const secondaryLocale = i18n.locale === 'en' ? 'fr' : 'en';
  const secondaryMessage = getMessages(secondaryLocale)[id];
  const secondary = new IntlMessageFormat(secondaryMessage || id || '', secondaryLocale).format(values);

  return `${primary} / ${secondary}`;
}

export default (id, values, bilingual = false) => {
  const message = i18n.messages[id];
  if (!message && import.meta.env.DEV) {
    console.error(`[i18n.t] Cannot format message: "${id}", using message id as fallback.`);
  }

  if (bilingual) {
    return bilingualMessage(id, values);
  }
  
  return new IntlMessageFormat(message || id || '', i18n.locale).format(values);
};
